import { AttioSortDirection, AttioValuationFilter } from 'dashboard409a/common/constants/analyst-dashboard';
import { AttioBulkService } from './attio/AttioBulkService';
import { AttioValuationService } from './attio/AttioValuationService';
import { SimplifiedAttioValuation } from './attio.types';

// Create singleton instances of the services
const valuationService = new AttioValuationService();
const bulkService = new AttioBulkService();

export const createAttioSort = (orderBy: string, order: AttioSortDirection) =>
  AttioValuationService.createAttioSort(orderBy, order);

export const updateValuation = (valuationId: string, valuation: SimplifiedAttioValuation) =>
  valuationService.updateValuation(valuationId, valuation);

export const getAllAttioValuations = (params: {
  userRecordId: string;
  filters: AttioValuationFilter;
}) => valuationService.getAllValuations(params);

export const loadBulkNotes = (attioValuationIds: string[]) =>
  valuationService.loadBulkNotes(attioValuationIds);

// Bulk data loading
export const loadBulkConsultants = (consultantIds: string[], signal?: AbortSignal) =>
  bulkService.loadBulkConsultants(consultantIds, signal);

export const loadBulkEngagementManagers = (managerIds: string[], signal?: AbortSignal) =>
  bulkService.loadBulkEngagementManagers(managerIds, signal);

export const loadBulkDeals = (dealIds: string[], signal?: AbortSignal) =>
  bulkService.loadBulkDeals(dealIds, signal);

export const loadBulkValuations = (valuationIds: string[], signal?: AbortSignal) =>
  bulkService.loadBulkValuations(valuationIds, signal);

export const loadAllBulkData = (
  consultantIds: string[],
  managerIds: string[],
  dealIds: string[],
  signal?: AbortSignal
) => bulkService.loadAllBulkData(consultantIds, managerIds, dealIds, signal);
